import React, { useEffect, useState } from "react";

const PartnerLogosSection = () => {
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth <= 600 : false
  );

  const partners = [
    { name: "Herotec", logo: "/image/herotec1.png" },
    { name: "Ford", logo: "/image/ford1.png" },
    { name: "IT8", logo: "/image/it81.png" },
    { name: "VDL", logo: "/image/vdl1.png" },
  ];

  const allPartners = [...partners, ...partners, ...partners];

  // Track screen size (mobile grid vs desktop slider)
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 600);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Inject styles + marquee keyframe animation
  useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `
      .pls-section {
        width: 100%;
        background: #ffffff;
        padding: 32px 20px;
        overflow: hidden;
        position: relative;
        box-sizing: border-box;
        font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
      }

      .pls-container {
        max-width: 1200px;
        margin: 0 auto;
        padding: 0 16px;
      }

      .pls-eyebrow {
        text-align: center;
        font-size: 10px;
        font-weight: 700;
        letter-spacing: 1.6px;
        text-transform: uppercase;
        color: #0d7a93;
        margin: 0 0 8px 0;
      }

      .pls-heading {
        text-align: center;
        font-size: 14px;
        font-weight: 700;
        font-family: 'Montserrat', sans-serif;
        color: #14213d;
        margin: 0 auto 24px auto;
        line-height: 1.4;
        max-width: 640px;
      }

      .pls-heading-accent {
        color: #0d7a93;
        font-weight: 700;
      }

      .pls-slider-viewport {
        overflow: hidden;
        width: 100%;
      }

      .pls-slider {
        display: flex;
        align-items: center;
        gap: 20px;
        width: max-content;
        animation: partnerScroll 22s linear infinite;
      }

      .pls-slider:hover {
        animation-play-state: paused;
      }

      .pls-logo-card {
        flex-shrink: 0;
        width: 110px;
        height: 48px;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .pls-logo-img {
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
        filter: grayscale(35%);
        opacity: 0.85;
        transition: filter 0.3s ease, opacity 0.3s ease, transform 0.3s ease;
      }

      .pls-logo-card:hover .pls-logo-img {
        filter: grayscale(0%);
        opacity: 1;
        transform: scale(1.05);
      }

      .pls-grid {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 16px;
        justify-items: center;
      }

      .pls-grid .pls-logo-card {
        width: 100%;
        max-width: 130px;
        height: 52px;
      }

      @keyframes partnerScroll {
        0% { transform: translateX(0); }
        100% { transform: translateX(calc(-1 * (150px + 20px) * ${partners.length})); }
      }

      /* ===== Responsive ===== */
      @media (min-width: 600px) {
        .pls-section {
          padding: 40px 20px;
        }
        .pls-heading {
          font-size: 16px;
        }
        .pls-eyebrow {
          font-size: 11px;
        }
        .pls-logo-card {
          width: 130px;
          height: 56px;
        }
      }

      @media (min-width: 900px) {
        .pls-section {
          padding: 48px 20px;
        }
        .pls-heading {
          font-size: 18px;
          margin-bottom: 28px;
        }
        .pls-slider {
          gap: 32px;
        }
        .pls-logo-card {
          width: 150px;
          height: 62px;
        }
      }

      @media (max-width: 375px) {
        .pls-heading {
          font-size: 13px;
        }
        .pls-grid .pls-logo-card {
          height: 44px;
        }
      }

      @media (prefers-reduced-motion: reduce) {
        .pls-slider {
          animation: none;
        }
      }
    `;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, [partners.length]);

  return (
    <section className="pls-section">
      <div className="pls-container">
        <p className="pls-eyebrow">Trusted By</p>

        <h2 className="pls-heading">
          Partnering with the world's{" "}
          <span className="pls-heading-accent">
            leading clients and companies
          </span>
        </h2>

        {!isMobile ? (
          <div className="pls-slider-viewport">
            <div className="pls-slider">
              {allPartners.map((partner, index) => (
                <div className="pls-logo-card" key={index}>
                  <img
                    src={partner.logo}
                    alt={partner.name}
                    className="pls-logo-img"
                  />
                </div>
              ))}
            </div>
          </div>
        ) : (
          <div className="pls-grid">
            {partners.map((partner, index) => (
              <div className="pls-logo-card" key={index}>
                <img
                  src={partner.logo}
                  alt={partner.name}
                  className="pls-logo-img"
                />
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default PartnerLogosSection;